const BhVampError = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.70384 1.72881C5.28265 0.736556 6.71635 0.736553 7.29517 1.72881L10.8041 7.74418C11.3875 8.74416 10.6662 9.99998 9.50847 9.99998H2.49054C1.33286 9.99998 0.611547 8.74417 1.19487 7.74418L4.70384 1.72881ZM6 4C6.27614 4 6.5 4.22386 6.5 4.5V6C6.5 6.27614 6.27614 6.5 6 6.5C5.72386 6.5 5.5 6.27614 5.5 6V4.5C5.5 4.22386 5.72386 4 6 4ZM5.375 7.5C5.375 7.15482 5.65482 6.875 6 6.875C6.34518 6.875 6.625 7.15482 6.625 7.5C6.625 7.84518 6.34518 8.125 6 8.125C5.65482 8.125 5.375 7.84518 5.375 7.5Z"
      fill="currentColor"
    />
  </svg>
)

export default BhVampError
